import React from 'react';
import {PropTypes} from 'prop-types';
import {getIsPointerSupported} from '../../../../utils/DomHelper';

function _getCallbackWithDebounce(callback) {
    let handled = false;
    return (event) => {
        if (!handled) {
            handled = true;
            callback(event);
            /**
             * We revert handled to false via setTimeout so that action to set the value will be
             * appended to the end of the event loop's queue. This guarantees that
             * if both `click` and `touchstart` have been registered, only the first call back
             * invoked should see a `handled` value of `false` and the second always a
             * `handled` value of `true`.
             *
             * We do not use e.preventDefault(), e.stopPropagation() or e.stopImmediatePropagation()
             * as any of those options prohibit the bubbling of the event to parent elements
             * and responsibility for that choice is the domain of the callback given to this method.
             */
            setTimeout(() => {
                handled = false;
            }, 0);
        }
    };
}

class Button extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        children: PropTypes.node,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        label: PropTypes.string,
        onClick: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            hasFocus: false,
        };
    }

    _onEnter = () => {
        this.setState({hasFocus: true});
    };

    _onExit = () => {
        this.setState({hasFocus: false});
    };

    _onClick = () => {
        if (this.props.onClick) {
            this.props.onClick(this.props.id);
        }
    };

    _onKeyPress = (e) => {
        let code = event.keyCode;
        if (code === 13 || code === 32) {
            this._onClick();
        }
    };

    _onClickWithDebounce = _getCallbackWithDebounce(this._onClick);

    render() {
        let isPointerSupported = getIsPointerSupported();
        let props = this.props;
        return (
            <button
                className={props.className}
                onKeyPress={this._onKeyPress}
                onPointerDown={isPointerSupported ? this._onClick : null}
                onMouseDown={isPointerSupported ? null : this._onClickWithDebounce}
                onTouchStart={isPointerSupported ? null : this._onClickWithDebounce}
                onMouseEnter={this._onExit}
                onMouseLeave={this._onEnter}
                disabled={props.disabled}
            >
                {props.label}
                {props.children}
            </button>
        );
    }
}

export default Button;
